function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import _ from 'lodash';
import React, { useState } from 'react';
import { DataTestId } from '@jvs-group/jvs-mairistem-tools';
import { Modal, Button } from "../..";
import ModalConfirm from "./ModalConfirm";
import { getRest } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
/** A collection list modal. */
var CollectionListModal = function CollectionListModal(props) {
  var _useState = useState(false),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState(false),
    confirmOpen = _useState2[0],
    setConfirmOpen = _useState2[1];
  // Pour savoir si on arrive dans la confirm depuis le clic sur enregistrer ou annuler / dimmer
  var _useState3 = useState(null),
    confirmFrom = _useState3[0],
    setConfirmFrom = _useState3[1];

  /**
   * Handle Primary Click event.
   */
  var handlePrimaryClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event, confirmationsData) {
      var confirmOn, open;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (confirmationsData === void 0) {
              confirmationsData = null;
            }
            confirmOn = props.confirmOn, open = props.open;
            if (!(confirmOn === 'primaryClick' && !confirmOpen)) {
              _context.next = 8;
              break;
            }
            // Si on veut ouvrir la confirmation au clic sur enregistrer (et que la confirm est fermée)
            // On court-circuite le reste et on ouvre juste la modale
            setLoading(true);
            setConfirmOpen(true);
            setConfirmFrom('primaryClick');
            _context.next = 15;
            break;
          case 8:
            setLoading(true);
            setConfirmOpen(false);
            setConfirmFrom(null);
            if (!open) {
              _context.next = 14;
              break;
            }
            _context.next = 14;
            return _.invoke(props, 'onPrimaryClick', event, confirmationsData);
          case 14:
            setLoading(false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handlePrimaryClick(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  /** Handle Secondary Click event. */
  var handleSecondaryClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var confirmOn, open;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            confirmOn = props.confirmOn, open = props.open;
            if (!(confirmOn === 'secondaryClick' && !confirmOpen)) {
              _context2.next = 7;
              break;
            }
            // Si on veut ouvrir la confirmation au clic sur annuler (et que la confirm est fermée)
            // On court-circuite le reste et on ouvre juste la modale
            setLoading(true);
            setConfirmOpen(true);
            setConfirmFrom('secondaryClick');
            _context2.next = 14;
            break;
          case 7:
            setLoading(true);
            setConfirmOpen(false);
            setConfirmFrom(null);
            if (!open) {
              _context2.next = 13;
              break;
            }
            _context2.next = 13;
            return _.invoke(props, 'onSecondaryClick', event);
          case 13:
            setLoading(false);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSecondaryClick(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * Handle Confirm back click.
   */
  var handleConfirmBackClick = function handleConfirmBackClick(event) {
    var _props$confirmProps = props.confirmProps,
      _props$confirmProps2 = _props$confirmProps === void 0 ? {} : _props$confirmProps,
      onBackClick = _props$confirmProps2.onBackClick;
    if (onBackClick) {
      onBackClick(event);
    }

    // On ferme la modal de confirmation et on retourne sur le formulaire
    setLoading(false);
    setConfirmOpen(false);
  };

  /**
   * Handle Confirm primary click.
   */
  var handleConfirmPrimaryClick = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
      var _props$confirmProps3, _props$confirmProps4, onPrimaryClick, confirmationsData;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _props$confirmProps3 = props.confirmProps, _props$confirmProps4 = _props$confirmProps3 === void 0 ? {} : _props$confirmProps3, onPrimaryClick = _props$confirmProps4.onPrimaryClick;
            confirmationsData = null;
            /*
                 * /!\ Si le dev fait un setState dans sa fonction "onPrimaryClick"
                 * /!\ Son composant n'aura pas le temps de se rerender
                 * /!\ et par conséquent ne sera pas à jour lorsque
                 * /!\ sa fonction de création / modification sera appelée juste après.
                 * /!\ Donc on donne au dev la possibilité de fournir
                 * /!\ des informations supplémentaires à ses fonctions de création / modification
                 * /!\ En renvoyant des données ici, pour qu'on puisse lui transmettre nous même plus tard
                 */
            if (!onPrimaryClick) {
              _context3.next = 6;
              break;
            }
            _context3.next = 5;
            return onPrimaryClick(event);
          case 5:
            confirmationsData = _context3.sent;
          case 6:
            if (confirmFrom === 'primaryClick') {
              // C'est bien handlePrimaryClick,
              // on veut quand même déclencher le clic du bouton primaire d'origine (enregistrer)
              handlePrimaryClick(event, confirmationsData);
            }
            if (confirmFrom === 'secondaryClick') {
              handleSecondaryClick(event);
            }
          case 8:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleConfirmPrimaryClick(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  /** Handle Confirm primary click. */
  var handleConfirmSecondaryClick = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event) {
      var _props$confirmProps5, _props$confirmProps6, onSecondaryClick, confirmationsData;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _props$confirmProps5 = props.confirmProps, _props$confirmProps6 = _props$confirmProps5 === void 0 ? {} : _props$confirmProps5, onSecondaryClick = _props$confirmProps6.onSecondaryClick;
            confirmationsData = null;
            /*
                 * /!\ Si le dev fait un setState dans sa fonction "onSecondaryClick"
                 * /!\ Son composant n'aura pas le temps de se rerender
                 * /!\ et par conséquent ne sera pas à jour
                 * /!\ lorsque sa fonction de création / modification sera appelée juste après.
                 * /!\ Donc on donne au dev la possibilité de fournir
                 * /!\ des informations supplémentaires à ses fonctions de création / modification
                 * /!\ En renvoyant des données ici, pour qu'on puisse lui transmettre nous même plus tard
                 */
            if (!onSecondaryClick) {
              _context4.next = 6;
              break;
            }
            _context4.next = 5;
            return onSecondaryClick(event);
          case 5:
            confirmationsData = _context4.sent;
          case 6:
            if (confirmFrom === 'primaryClick') {
              // C'est bien handlePrimaryClick,
              // on veut quand même déclencher le clic du bouton primaire d'origine (enregistrer)
              handlePrimaryClick(event, confirmationsData);
            }
            if (confirmFrom === 'secondaryClick') {
              handleSecondaryClick(event);
            }
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleConfirmSecondaryClick(_x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  /** Render the actions. */
  var renderActions = function renderActions() {
    var actions = props.actions,
      color = props.color,
      confirmProps = props.confirmProps,
      primaryButton = props.primaryButton,
      secondaryButton = props.secondaryButton;
    return /*#__PURE__*/_jsxs(Modal.Actions, {
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          "float": 'left'
        },
        children: actions
      }), /*#__PURE__*/_jsx(DataTestId.Accessor, {
        dataTestId: "collection-modal-secondary",
        children: function children(dataTestId) {
          return /*#__PURE__*/_jsx(Button, Object.assign({
            "data-testid": dataTestId,
            basic: true,
            size: "tiny"
          }, secondaryButton, {
            onClick: handleSecondaryClick,
            disabled: loading
          }));
        }
      }), /*#__PURE__*/_jsx(DataTestId.Accessor, {
        dataTestId: "collection-modal-primary",
        children: function children(dataTestId) {
          return /*#__PURE__*/_jsx(Button, Object.assign({
            "data-testid": dataTestId,
            primary: true,
            onClick: handlePrimaryClick,
            disabled: loading
          }, primaryButton));
        }
      }), confirmOpen && /*#__PURE__*/_jsx(ModalConfirm, Object.assign({
        color: color
      }, confirmProps, {
        /** On surcharge ces trois là mais on appelle les props correspondante à l'intérieur. */
        onBackClick: handleConfirmBackClick,
        onPrimaryClick: handleConfirmPrimaryClick,
        onSecondaryClick: handleConfirmSecondaryClick
      }))]
    }, "actions");
  };
  renderActions.handledProps = [];
  var render = function render() {
    var children = props.children,
      content = props.content,
      className = props.className,
      color = props.color,
      open = props.open,
      modal = props.modal,
      modalContentProps = props.modalContentProps;
    var rest = getRest(CollectionListModal, props);
    if (!(_.isNil(children) || _.isEmpty(children))) {
      return /*#__PURE__*/_jsxs(Modal, Object.assign({}, rest, {
        className: className,
        open: open,
        onClose: handleSecondaryClick,
        closeOnDimmerClick: true,
        closeIcon: true,
        colorHeader: color
      }, modal, {
        children: [children, renderActions()]
      }));
    }
    if (! /*#__PURE__*/React.isValidElement(content) && _.isPlainObject(content)) {
      return /*#__PURE__*/_jsx(Modal, Object.assign({}, rest, {
        className: className,
        open: open,
        onClose: handleSecondaryClick,
        closeOnDimmerClick: true,
        closeIcon: true,
        colorHeader: color
      }, modal, {
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [Modal.Content.create(content), renderActions()]
        })
      }));
    }
    return /*#__PURE__*/_jsx(Modal, Object.assign({}, rest, {
      className: className,
      open: open,
      onClose: handleSecondaryClick,
      closeOnDimmerClick: true,
      closeIcon: true,
      colorHeader: color
    }, modal, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Modal.Content, Object.assign({}, modalContentProps, {
          children: content
        })), renderActions()]
      })
    }));
  };
  render.handledProps = [];
  return render();
};
CollectionListModal.handledProps = [];
export default CollectionListModal;